import { REPORTING_TIME_ZONE } from './reportingTime';

// Group a list into day buckets by a datetime field, newest day first.
// Day boundaries use the app's reporting timezone (same as the rest of the
// console) so a request made late evening lands on the day the user saw it.
// Returns [{ key, label, items }] with labels "Today" / "Yesterday" / "Mon, Aug 25, 2026".
export function groupByDay(items, dateField = 'created_at') {
  const dayKey = (d) =>
    new Intl.DateTimeFormat('en-CA', {
      timeZone: REPORTING_TIME_ZONE,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).format(d); // -> "YYYY-MM-DD"

  const today = dayKey(new Date());
  const yDate = new Date();
  yDate.setDate(yDate.getDate() - 1);
  const yesterday = dayKey(yDate);

  const buckets = new Map();
  for (const it of items || []) {
    const raw = it?.[dateField];
    const d = raw ? new Date(raw) : null;
    const key = d && !isNaN(d.getTime()) ? dayKey(d) : 'unknown';
    if (!buckets.has(key)) buckets.set(key, []);
    buckets.get(key).push(it);
  }

  const labelFor = (key) => {
    if (key === today) return 'Today';
    if (key === yesterday) return 'Yesterday';
    if (key === 'unknown') return 'Earlier';
    const [yr, mo, da] = key.split('-').map(Number);
    return new Intl.DateTimeFormat('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    }).format(new Date(yr, mo - 1, da));
  };

  return [...buckets.keys()]
    .sort((a, b) => {
      if (a === 'unknown') return 1;
      if (b === 'unknown') return -1;
      return a < b ? 1 : a > b ? -1 : 0; // newest day first
    })
    .map((key) => ({ key, label: labelFor(key), items: buckets.get(key) }));
}
